import { InjectionToken, NgModule } from '@angular/core';
import { RouteUtilService } from '../utils/route-util.service';
import { ToastService } from '../utils/toast.service';
import { ToastrModule } from 'ngx-toastr';
import { DirectivesModule } from './directives.module';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/modules/material.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

export const LOCATION_TOKEN = new InjectionToken<Location>('Window location object');
@NgModule({
  
  imports: [
    ToastrModule.forRoot(),
    DirectivesModule,
    MaterialModule,
    FontAwesomeModule
  ],
  exports: [
    DirectivesModule,
    MatDialogModule,
    MaterialModule,
    FontAwesomeModule
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {}
    },
    RouteUtilService,
    ToastService,
    { provide: LOCATION_TOKEN, useValue: window.location }

  ]
})
export class SharedModule {}
